import {useCallback, useState} from "react";
import {CourtBigModel, CourtsRequests, CourtUpdateStatusRequestModel} from "@/app/api/courts";
import {UserRequests} from "@/app/api/user";

interface ScreenState {
  hasError?: string;
  hasLoading?: boolean;
  courts: CourtBigModel[]
}

const useCourtVerification = () => {
  const [state, setState] = useState<ScreenState>({
    hasError: undefined,
    hasLoading: true,
    courts: []
  });

  const approvedEmails = ["dylanwoodakers@gmail.com", "pavlogrinchenkoo@gmail.com", "ceo.danaassist@gmail.com"];

  const updateState = useCallback((updates: Partial<ScreenState>) => {
    setState((prev) => ({...prev, ...updates}));
  }, []);

  const init = useCallback(async () => {
    try {
      const user = await UserRequests.getCurrentUser();
      if (!approvedEmails.includes(user.user.email?.toLowerCase() ?? "")) {
        updateState({hasError: "You do not have access to this page.", hasLoading: false});
        return;
      }
      const response = await CourtsRequests.getDraftCourts();
      updateState({courts: response});
    } catch (error: any) {
      updateState({hasError: error.message});
    } finally {
      updateState({hasLoading: false});
    }
  }, [updateState]);

  const onApprove = useCallback(async (courtId: number) => {
    const req: CourtUpdateStatusRequestModel = {draftCourtId: courtId, decision: true};
    const response = await CourtsRequests.updateDraftCourtStatus(req);
    if (response) {
      await init();
    }
  }, []);

  const onReject = useCallback(async (courtId: number) => {
    const req: CourtUpdateStatusRequestModel = {draftCourtId: courtId, decision: false};
    const response = await CourtsRequests.updateDraftCourtStatus(req);
    if (response) {
      await init();
    }
  }, []);

  return {
    state,
    init,
    onApprove,
    onReject
  };
};

export default useCourtVerification;